export default "__VITE_ASSET__C9SQ9pa3__"